module.exports = __webpack_public_path__ + "img/video.12fc060e.jpg";